module.exports = __webpack_public_path__ + "favicon/favicon_wide_310.647f37e7.png";